import { IsNotEmpty, IsUUID, IsInt, IsOptional, IsISO8601, IsString, IsArray, MinLength, MaxLength, IsBoolean } from 'class-validator';

export class CalendarEventEditParticipantsDTO {

    @IsNotEmpty()
    @IsUUID()
    id: string;

    @IsNotEmpty()
    @IsInt()
    type: number;

    @IsNotEmpty()
    @IsInt()
    status: number;

    @IsOptional()
    @IsISO8601()
    start: string;

    @IsOptional()
    @IsISO8601()
    end: string;

    @IsOptional()
    @IsString()
    recurrence: string;

    @IsOptional()
    @IsInt()
    duration: number;

    @IsOptional()
    @IsInt()
    reminderType: number;

    @IsOptional()
    @IsInt()
    reminderUnit: number;

    @IsOptional()
    @IsInt()
    reminderValue: number;

    @IsOptional()
    @IsISO8601()
    reminderDate: string;

    @IsNotEmpty()
    @IsBoolean()
    reminderProcessed: boolean;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    categories: Array<string>;

}
